import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
}))

export const Group = styled.section(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  maxWidth: '100%',
  width: '80rem',
}))

export const GroupTitle = styled.h2(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.6rem',
  fontWeight: 600,
  margin: 0,
}))

export const List = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  width: '100%',
}))

export const Item = styled.div(({ theme }) => ({
  // Note: no row highlight while the copy button is hovered - it has its own action.
  '&:hover:not(:has(button:hover))': { backgroundColor: theme.colors.gray100 },
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  cursor: 'pointer',
  display: 'flex',
  gap: theme.space['16'],
  justifyContent: 'space-between',
  minHeight: '4.8rem',
  padding: `${theme.space['8']} ${theme.space['16']}`,
  position: 'relative',
  width: '100%',
}))

export const Name = styled.div({
  flex: 1,
  minWidth: 0,
  textAlign: 'left',
})

// Note: the ::after stretches the link over the whole row, so the row is a real link (Ctrl/Cmd-click,
// middle-click, URL on hover). Meta and the copy button sit above it (z-index) and stay clickable.
export const NameLink = styled(Link)(({ theme }) => ({
  '&::after': { content: '""', inset: 0, position: 'absolute' },
  '&:focus-visible': {
    borderRadius: theme.border.radius['4'],
    outline: `${theme.border.size['2']} solid ${theme.colors.blue500}`,
  },
  '&:hover': {
    color: theme.colors.blue500,
    textDecorationColor: theme.colors.blue500,
  },
  color: theme.colors.black800,
  fontSize: '1.4rem',
  textDecoration: 'underline',
  textDecorationColor: theme.colors.black300,
  textDecorationThickness: theme.border.size['1'],
  textUnderlineOffset: '0.25rem',
  transition: `color ${theme.transition.duration.sm} ease, text-decoration-color ${theme.transition.duration.sm} ease`,
}))

export const Meta = styled.div(({ theme }) => ({
  alignItems: 'center',
  color: theme.colors.black400,
  display: 'flex',
  flexShrink: 0,
  fontSize: '1.4rem',
  gap: theme.space['16'],
  position: 'relative',
  zIndex: 1,
}))

export const ExternalLink = styled.a(({ theme }) => ({
  '&:hover': { textDecoration: 'underline' },
  color: theme.colors.blue500,
}))

export const CopyWrapper = styled.div({
  display: 'flex',
  position: 'relative',
  zIndex: 1,
})
